<mat-form-field>
  <mat-label>{{ label() }}</mat-label>

  <input matInput type="text" [placeholder]="placeholder()" [formControl]="formControl" />

  <span matSuffix>
    @if (formControl.value) {
      <button
        mat-icon-button
        (click)="$event.stopPropagation()"
        (click)="clearSearchQuery()"
      >
        <mat-icon>close</mat-icon>
      </button>
    } @else {
      <mat-icon>search</mat-icon>
    }
  </span>
</mat-form-field>
